import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import { ProvisionPage } from 'Src/feature/provision/ProvisionPage';
import useRoute from 'Src/routes/useRoute';

import ClaimTerminal from './ClaimTerminal';
import { EnterToken } from './EnterToken';
import ProgressStepper from './ProgressStepper';
import { StepperFooter } from './StepperFooter';
import { Step, TokenWorkFlowStoreProvider, useTokenWorkflow } from './useTokenWorkflow';

const TokenWorkflow: FC = () => {
  const { t } = useTranslation();
  const { crumbs, navigate } = useRoute();
  const workflow = useTokenWorkflow();

  return (
    <ProvisionPage
      header={<Copy variant="h6" value={t('labels.getStarted')} />}
      content={{
        header: (
          <ProgressStepper activeStep={workflow.steps.current} steps={Object.values(workflow.steps.labels)}  />
        ),
        main: ((() => {
          switch (workflow.steps.current) {
            case Step.EnterToken:
              return <EnterToken />;
            case Step.Review:
              return (
                <ClaimTerminal
                  domEventName="tokenWorkflow.onGoNext"
                  location={workflow.data.location}
                  terminal={workflow.data.terminal}
                />
              );
            default: return null;
          }
        })()),
        footer: (
          <StepperFooter
            canGoPrev={workflow.steps.isFirst || workflow.steps.canGoPrev}
            canGoNext={workflow.steps.canGoNext}
            onPrevRequested={() => {
              if (workflow.steps.isFirst) {
                navigate(crumbs.provision.main.path);
              } else {
                workflow.steps.goPrev();
              }
            }}
            onNextRequested={() => workflow.steps.goNext()}
            nextLabel={workflow.steps.isFinal ? t('provision.labels.claim') : undefined}
          />
        ),
      }}
    />
  );
};

// eslint-disable-next-line react/no-multi-comp
const TokenWorkflowWithProvider: FC = () => (
  <TokenWorkFlowStoreProvider>
    <TokenWorkflow />
  </TokenWorkFlowStoreProvider>
);

export default TokenWorkflowWithProvider;
